class ImpersonateModalController {
  constructor($scope, $uibModalInstance, $uibModal, $rootScope, AuthenticationService, $timeout, $http) {
      "ngInject";
      this.name = 'impersonateModal';

      let self = this;
      this.http = $http;
      $scope.impersonating = false;

      $http.get($rootScope.apiHost+'/api/admin/users/names', {withCredentials: true}).then(function (success) {
        $scope.activeUsers = success.data;
      });


      $scope.done = function() {
          $uibModalInstance.dismiss('cancel');
      }

      $scope.cancel = function () {
          $uibModalInstance.dismiss('cancel');
      };


      $scope.impersonateUser = function(user) {
        $scope.impersonating = true;
        $http.get($rootScope.apiHost+'/api/impersonate?username='+ user.userName, {withCredentials: true})
          .then(function (success) {
            // Handle successful response (including 303 redirects that were followed)
            if (success.status >= 200 && success.status < 300) {
              window.location.href = './';
            }
          })
          .catch(function(response) {
            // Handle redirect responses (303, 302, 301) or other errors
            // For 303 redirects, navigate to home page
            if (response.status === 303 || response.status === 302 || response.status === 301) {
              window.location.href = './';
            } else if (response.status !== 0) {
              // Other errors - still navigate to home
              window.location.href = './';
            }
            // Status 0 usually means request was cancelled due to navigation, so do nothing
          });
      }

  }
}

export default ImpersonateModalController;



// WEBPACK FOOTER //
// ./client/common/modals/impersonateModal/impersonateModal.controller.js